var map = {
	"./wines-1988.json": [
		9445,
		445
	],
	"./wines-1989.json": [
		2762,
		762
	],
	"./wines-1990.json": [
		3392,
		392
	],
	"./wines-1991.json": [
		7424,
		43
	],
	"./wines-1992.json": [
		66,
		66
	],
	"./wines-1993.json": [
		1469,
		469
	],
	"./wines-1994.json": [
		1580,
		580
	],
	"./wines-1995.json": [
		1471,
		471
	],
	"./wines-1996.json": [
		1230,
		230
	],
	"./wines-1997.json": [
		7593,
		593
	],
	"./wines-1998.json": [
		8376,
		376
	],
	"./wines-1999.json": [
		7723,
		723
	],
	"./wines-2000.json": [
		6521,
		521
	],
	"./wines-2001.json": [
		2334,
		334
	],
	"./wines-2002.json": [
		9663,
		663
	],
	"./wines-2003.json": [
		2524,
		143
	],
	"./wines-2004.json": [
		3405,
		405
	],
	"./wines-2005.json": [
		3970,
		970
	],
	"./wines-2006.json": [
		8227,
		227
	],
	"./wines-2007.json": [
		7888,
		888
	],
	"./wines-2008.json": [
		9025,
		25
	],
	"./wines-2009.json": [
		9238,
		238
	],
	"./wines-2010.json": [
		9948,
		948
	],
	"./wines-2011.json": [
		8911,
		911
	],
	"./wines-2012.json": [
		4542,
		542
	],
	"./wines-2013.json": [
		4377,
		377
	],
	"./wines-2014.json": [
		6496,
		496
	],
	"./wines-2015.json": [
		7827,
		827
	],
	"./wines-2016.json": [
		6802,
		802
	],
	"./wines-2017.json": [
		8253,
		253
	],
	"./wines-2018.json": [
		1524,
		524
	],
	"./wines-2019.json": [
		9559,
		559
	],
	"./wines-2020.json": [
		9479,
		479
	],
	"./wines-2021.json": [
		4084,
		84
	],
	"./wines-2022.json": [
		5825,
		825
	],
	"./wines-2023.json": [
		4790,
		790
	],
	"./wines-2024.json": [
		1675,
		675
	],
	"./wines-2025.json": [
		264
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4046;
module.exports = webpackAsyncContext;